export const mobileApiNm = {
  getDriverRegNum: "/mobile/getDriverRegNum",
  getDriverJob: "/mobile/getDriverJob",
  deleteDriverRegNum: "/mobile/deleteDriverRegNum",
  registerRegNum: "/mobile/registerRegNum",
  deleteDriverMobile: "/mobile/deleteDriverMobile",
}